module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "e-icon",
    class: _vm.feature,
    attrs: {
      "data-name": _vm.name
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": '/assets/img/svg/icons.svg#' + _vm.name
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fac59a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/component/icon.vue
// module id = 60
// module chunks = 0